import I18n from 'I18n';
import { DownIcon, RightIcon } from 'foundations-assets';
import { FolderNav, FolderNavItem } from 'foundations-components/transitional/components/FolderNav';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default class EmailFolderSelectTree extends Component {
  getFolderClickHandler(folderId, folderName) {
    const {
      onSelect
    } = this.props;
    return () => {
      if (typeof onSelect === 'function') {
        onSelect(folderId, folderName);
      }
    };
  }
  renderFolders(folders, selectedFolderId) {
    return folders.map((folder, id) => {
      const hasChildren = folder.childFolders.size > 0;
      return /*#__PURE__*/_jsx(FolderNavItem, {
        defaultOpen: hasChildren && id === selectedFolderId,
        iconRight: ({
          open
        }) => hasChildren && (open ? /*#__PURE__*/_jsx(DownIcon, {
          size: "300"
        }) : /*#__PURE__*/_jsx(RightIcon, {
          size: "300"
        })),
        onClick: this.getFolderClickHandler(id, folder.name),
        title: folder.name,
        value: id,
        children: hasChildren && this.renderFolders(folder.childFolders)
      }, id);
    }).toArray();
  }
  render() {
    const {
      folders,
      selectedFolderId
    } = this.props;
    return /*#__PURE__*/_jsx(FolderNav, {
      value: selectedFolderId,
      children: /*#__PURE__*/_jsx(FolderNavItem, {
        defaultOpen: true,
        onClick: this.getFolderClickHandler(0),
        title: I18n.text('email-management.table.breadcrumbs.home'),
        value: 0,
        children: this.renderFolders(folders, selectedFolderId)
      })
    });
  }
}